export * from '@airgap/beacon-core';
export * from '@airgap/beacon-transport-matrix';
export * from '@airgap/beacon-types';
export * from '@airgap/beacon-utils';
import { WalletClient } from './client/WalletClient';
export { WalletClient };
//# sourceMappingURL=index.js.map